<section class="vc-admin-entity-detail">
  <app-admin-page-header
    titleKey="ADMIN.JOBS.TITLE"
    descriptionKey="ADMIN.IA.JOBS.DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    contextLabelKey="COMMON.NAME"
    [contextValue]="job?.name || ''"
  ></app-admin-page-header>

  <div class="vc-admin-entity-detail__content">
    <nav class="vc-admin-detail__tabs">
      <a class="vc-admin-detail__tab active" aria-current="page">
        <i class="fas fa-pen"></i>
        <span>{{ 'COMMON.EDIT' | translate }}</span>
      </a>
    </nav>

    @if (loading) {
      <app-admin-state-panel
        mode="loading"
        titleKey="COMMON.LOADING"
      ></app-admin-state-panel>
    } @else if (hasError || !job) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.JOBS.ERROR.LOAD"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else {
      <app-admin-form-layout>
        <app-form-job [payload]="job" [showIntro]="false" [onUpdate]="reload"></app-form-job>
      </app-admin-form-layout>
    }
  </div>
</section>
